import { useEffect } from "react";

export default function SenjaWidget() {
  useEffect(() => {
    const existing = document.querySelector('script[src*="widget.senja.io"]');
    if (!existing) {
      const script = document.createElement("script");
      script.src = "https://widget.senja.io/widget/f076d57a-a4ab-454e-9621-979bcb01916a/platform.js";
      script.type = "text/javascript";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <section className="py-20 sm:py-24 bg-[#0A0C10] border-b border-[#181B23]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto text-center mb-12 space-y-2">
          <span className="text-xs font-semibold uppercase tracking-wider text-[#CC3737]">
            Client Testimonials
          </span>
          <h2 className="text-2xl sm:text-4xl font-extrabold text-white tracking-tight">
            What clients say
          </h2>
          <p className="text-sm text-[#94A3B8]">
            Feedback from founders, teams, and partners.
          </p>
        </div>

        <div className="w-full max-w-5xl mx-auto overflow-hidden">
          <div 
            className="senja-embed" 
            data-id="f076d57a-a4ab-454e-9621-979bcb01916a" 
            data-mode="shadow" 
            data-lazyload="false" 
            style={{ display: "block", width: "100%" }}
          />
        </div>
      </div>
    </section>
  );
}
